// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"4228918d","158":"f152cdef","628":"b9d79bc8","798":"d6420f13","845":"b14f390f"}[chunkId] + ".chunk.js";
};